import _defineProperty from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.assign";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
export var TEXTAREA_DEFAULTS = {
  sizes: ["small", "medium", "large"],
  states: ["focused", "hovered"]
};
export var Textarea = forwardRefAs(function (_a, ref) {
  var _classNames;

  var className = _a.className,
      color = _a.color,
      fixedSize = _a.fixedSize,
      size = _a.size,
      state = _a.state,
      rest = tslib_1.__rest(_a, ["className", "color", "fixedSize", "size", "state"]);

  return React.createElement(Generic, Object.assign({
    className: classNames("textarea", (_classNames = {
      "has-fixed-size": fixedSize
    }, _defineProperty(_classNames, "is-".concat(color), color), _defineProperty(_classNames, "is-".concat(size), size), _defineProperty(_classNames, "is-".concat(state), state), _classNames), className),
    ref: ref
  }, rest));
}, {
  as: "textarea",
  rows: 4
});
Textarea.displayName = "Textarea";
Textarea.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fixedSize: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};